import { Inject, Injectable } from '@angular/core';
import { environment } from '@fantaz/shared/app-config';
import type { ApiEndpoints } from '../api-endpoints';
import { API_ENDPOINTS } from './api-endpoints.provider';

@Injectable({
  providedIn: 'root',
})
export class ApiEndpointsPaths {
  baseUrl = environment.baseURL;
  endpoints: ApiEndpoints = {} as ApiEndpoints;

  constructor(@Inject(API_ENDPOINTS) private _endpoints: ApiEndpoints[]) {
    this.endpoints = _endpoints.reduce(
      (acc: ApiEndpoints, current: ApiEndpoints) => {
        return {
          ...current,
          ...acc,
        };
      },
      {} as ApiEndpoints,
    );
  }

  /**
   * Resolves the URL by replacing any route parameters with their corresponding
   * values. It includes the base URL from the environment configuration.
   *
   * @param url - The URL string with optional route parameters.
   * @param params - An object containing key-value pairs of route parameters and their values.
   * @returns The resolved URL string.
   *
   * @usageNotes
   * ```typescript
   *
   * ### Inject service
   * const apiEndpointsPaths = inject(ApiEndpointsPaths);
   *
   * ### Resolve URL using `resolve` method and `nameOfRoute` endpoint on the
   * ###`endpoints` object. This value is defined in the `api-endpoints.config.ts`
   * ### file.
   * const url = apiEndpointsPaths.resolve(this.apiEndpointsPaths.endpoints.nameOfRoute);
   *
   * ```
   */
  resolve(path: string, params?: Record<string, string>): string {
    if (params) {
      path = Object.keys(params).reduce(
        (acc, param) => acc.replace(`:${param}`, params[param]),
        path,
      );
    }

    return `${this.baseUrl}/${path}`;
  }
}
